<template>
  <router-view/>
</template>

<script setup>
  import EventBus from '@/composables/bus.js'
  import { onMounted, watch } from 'vue'
  import { useI18n } from 'vue-i18n'
  import './assets/css/app.css'

  const { locale } = useI18n()

  // Screenreader müssen anhand von <html lang> die richtige Aussprache wählen.
  // Das Attribut wird initial gesetzt und bei jedem Locale-Wechsel aktualisiert.
  // Die Locale-Codes (de, en, fr) entsprechen bereits gültigen BCP-47-Kürzeln.
  const applyDocumentLang = () => document.documentElement.lang = locale.value


  // --primaryColor/--primaryColorDark werden jetzt statisch in :root
  // (assets/css/app.css) deklariert. Für White-Label kann eine spätere
  // Integration sie weiterhin per JS auf document.documentElement setzen.

  const applyEventListeners = () => {
    const onClick = () => EventBus.emit({ type: 'close' })

    document.addEventListener('click', onClick)
  }

  onMounted(() => {
    applyEventListeners()
  })

  watch(locale, applyDocumentLang, { immediate: true })
</script>

<style lang="css">
  @import '@app-css' reference;

  html,
  body,
  #app {
    @apply
      w-full
      h-full
      font-light
      font-primary
      overflow-auto;
  }
</style>
